import type {Content} from './Content';

export type ParamValue = {
  value: string;
  openCategoryWithKey: string | null;
  content: Content;
  featureKey: string | null;
};
